import { useState, useEffect, useCallback } from 'react';
import { menuService } from '../../../../services/menuService';
import { useAlert } from '../../../../context/AlertContext';

// Menü verisini savunmacı şekilde normalize eder: categories ve her category.items
// mutlaka dizi olur. Bozuk/eski kayıtlar (items bir obje/string olarak gelmiş) UI'ı
// çökertmesin diye guard.
const normalizeMenu = (menu) => {
    if (!menu || typeof menu !== 'object') return menu;
    const categories = Array.isArray(menu.categories) ? menu.categories : [];
    return {
        ...menu,
        categories: categories.map((cat) => ({
            ...cat,
            items: Array.isArray(cat?.items) ? cat.items : [],
        })),
    };
};

export const useMenuData = (effectiveTenantId, tenantData) => {
    const { showAlert, showConfirm } = useAlert();
    const [savedMenu, setSavedMenu] = useState(null);
    const [generatedMenu, setGeneratedMenu] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const loadMenu = async () => {
            setLoading(true);
            try {
                const data = await menuService.fetchMenu(effectiveTenantId);
                if (data) {
                    setSavedMenu(normalizeMenu(data));
                } else {
                    setGeneratedMenu({
                        menuName: tenantData?.name || 'Menü',
                        description: '',
                        categories: [],
                        designRecommendation: {}
                    });
                }
            } catch (err) {
                setError('Menü yüklenirken bir hata oluştu.');
            } finally {
                setLoading(false);
            }
        };
        loadMenu();
    }, [effectiveTenantId, tenantData?.name]);

    const handleSaveMenu = async (menuToSave, onSuccess) => {
        if (!menuToSave) return;

        const confirmed = await showConfirm('Menü değişikliklerini kaydetmek istediğinize emin misiniz?', {
            title: 'Menüyü Kaydet',
            confirmText: 'Kaydet',
            type: 'info'
        });
        if (!confirmed) return;

        setSaving(true);
        setError('');

        try {
            if (tenantData?.plan === 'free' && (menuToSave?.categories || []).length > 1) {
                showAlert('Ücretsiz planda kategori sınırına ulaştınız.', 'error');
                setSaving(false);
                return;
            }

            await menuService.saveMenu(effectiveTenantId, menuToSave);
            setSavedMenu(menuToSave);
            if (onSuccess) onSuccess();
            showAlert('Menü başarıyla kaydedildi!', 'success');
        } catch (err) {
            setError('Menü kaydedilirken bir hata oluştu: ' + err.message);
        } finally {
            setSaving(false);
        }
    };

    return {
        savedMenu, setSavedMenu,
        generatedMenu, setGeneratedMenu,
        loading, saving, error, setError,
        handleSaveMenu
    };
};